import Tooltip, { TooltipProps } from "@mui/material/Tooltip";
import styled from "styled-components";
// eslint-disable-next-line react/react-in-jsx-scope
export const StyledTooltip = styled(({ ...props }: TooltipProps) => <Tooltip {...props} />)``;
